import { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../../assets/img/header-img.png";
import { ArrowRightCircle } from "react-bootstrap-icons";
import React from "react";
import "./Banner3.css";
import CardGroup from "react-bootstrap/CardGroup";
import Card from "react-bootstrap/Card";
// import { ProjectCard } from "../ProjectCards/ProjectCard";

import TrackVisibility from "react-on-screen";
import ShowMoreText from "react-show-more-text";
import projImg21 from "../../assets/img/2-1.png";


import projectimage from "../../assets/img/p1.png";
import Card1 from "../CardComponents/Card1";
import Card2 from "../CardComponents/Card2";
import Card3 from "../CardComponents/Card3";
import Card4 from "../CardComponents/Card4";
import Card5 from "../CardComponents/Card5";
import Card6 from "../CardComponents/Card6";
import Card7 from "../CardComponents/Card7";
import Card8 from "../CardComponents/Card8";
import Card2024_1 from "../CardComponents/Card2024_1";
import Card2024_2 from "../CardComponents/Card2024_2";
import Gyorgy_Karolyi_stability from "../CardComponents/Gyorgy_Karolyi_stability";
import Gyorgy_Karolyi_dissip_billiards from "../CardComponents/Gyorgy_Karolyi_dissip_billiards";
import Zombor_Berezvai_bubi from "../CardComponents/Zombor_Berezvai_bubi";
import Andras_Kornai_anonymization from "../CardComponents/Andras_Kornai_anonymization";
import Attila_Kovacs_politics from "../CardComponents/Attila_Kovacs_politics";
import Balazs_Pejo_secure_private from "../CardComponents/Balazs_Pejo_secure_private";
import Gyorgy_Ottucsak_factor from "../CardComponents/Gyorgy_Ottucsak_factor";
import I_Miklos_and_B_Heilig_ionosphere from "../CardComponents/I_Miklos_and_B_Heilig_ionosphere";
import Zhang_Xinzhe_highway from "../CardComponents/Zhang_Xinzhe_highway";
import Balint_Daroczy_transformer from "../CardComponents/Balint_Daroczy_transformer";
import A_Lovas_and_B_Heilig_ionosphere from "../CardComponents/A_Lovas_and_B_Heilig_ionosphere";
import Gergely_Manasses_central_bank from "../CardComponents/Gergely_Manasses_central_bank";
import Luca_Szegletes_brain_imaging from "../CardComponents/Luca_Szegletes_brain_imaging";
import Luca_Szegletes_gnn_see from "../CardComponents/Luca_Szegletes_gnn_see";
import Balazs_Varga_geom_repr from "../CardComponents/Balazs_Varga_geom_repr";
import Tamas_Ormandi_vehicle_scheduling from "../CardComponents/Tamas_Ormandi_vehicle_scheduling";
import Tamas_Wagner_traffic_signal from "../CardComponents/Tamas_Wagner_traffic_signal";
import Mate_Gedeon_hidden_paths from "../CardComponents/Mate_Gedeon_hidden_paths";
import Mate_Gedeon_speech_recog from "../CardComponents/Mate_Gedeon_speech_recog";
import V_Weigl_Kovacs_and_B_Agg_network_viz from "../CardComponents/V_Weigl_Kovacs_and_B_Agg_network_viz";
import N_Friedman_and_A_Benczur_distr_learning from "../CardComponents/N_Friedman_and_A_Benczur_distr_learning";
import Cs_Kerepesi_and_K_Kovacs_age_prediction from "../CardComponents/Cs_Kerepesi_and_K_Kovacs_age_prediction";
import Beatrix_Sellei_psychology_academic from "../CardComponents/Beatrix_Sellei_psychology_academic";
import Imre_Varga_eigenv_stability from "../CardComponents/Imre_Varga_eigenv_stability";
import Gergo_Orban_deepgen from "../CardComponents/Gergo_Orban_deepgen";


export const Banner3 = () => {
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
  }
  const { height, width } = useWindowDimensions();

  let numberofcards = 3;
  let gSomething = "auto";
  let gSomethingElse = "g-5";
  let cardClass = "Card3";
  // console.log(width);

  if (width < "1200") {
    numberofcards = 2;
    gSomething = "g-3";
    gSomethingElse = "g-4";
    cardClass = "Card2";
  }

  const [isShown, setIsShown] = useState(false);



  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.history.pushState({}, "", "#projects");
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.2,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <section className="banner3" id="projects" ref={ref}>
      <Container>
      <h1>Available projects</h1>
        
      </Container>
     
      <Container className={gSomething}>
        <Row xs={1} md={numberofcards} className={gSomethingElse}>
          <Col>
            <Gergely_Manasses_central_bank/>
          </Col>
          <Col>
           <Beatrix_Sellei_psychology_academic/>
          </Col>
          <Col>
            <A_Lovas_and_B_Heilig_ionosphere/>
          </Col>
          <Col>
            <Balint_Daroczy_transformer/>
          </Col>
          <Col>
            <Zhang_Xinzhe_highway/>
          </Col>
          <Col>
            <I_Miklos_and_B_Heilig_ionosphere/>
          </Col>
          <Col>
            <Gyorgy_Ottucsak_factor/>
          </Col>
          <Col>
            <Balazs_Pejo_secure_private/>
          </Col>
          <Col>
            <Attila_Kovacs_politics/>  
          </Col>
          <Col>
            <Andras_Kornai_anonymization/>
          </Col>
          <Col>
            <Gyorgy_Karolyi_stability/>
          </Col>
          <Col>
            <Gyorgy_Karolyi_dissip_billiards/>
          </Col>
          <Col>
            <Luca_Szegletes_brain_imaging/>
          </Col>
          <Col>
            <Luca_Szegletes_gnn_see/>
          </Col>
          <Col>
            <Balazs_Varga_geom_repr/>
          </Col>
          <Col>
            <Tamas_Ormandi_vehicle_scheduling/>
          </Col>
          <Col> 
            <Tamas_Wagner_traffic_signal/>
          </Col>
          <Col>
            <Mate_Gedeon_hidden_paths/>
          </Col>
          <Col>
            <Mate_Gedeon_speech_recog/>
          </Col>
          <Col>
            <V_Weigl_Kovacs_and_B_Agg_network_viz/>
          </Col>
          <Col> 
            <Zombor_Berezvai_bubi/> 
          </Col>
          <Col> 
            <N_Friedman_and_A_Benczur_distr_learning/> 
          </Col>
          <Col>
            <Cs_Kerepesi_and_K_Kovacs_age_prediction/>
          </Col>
          <Col>
            <Imre_Varga_eigenv_stability/>
          </Col>
        </Row>
      </Container>

        

      
      <Container className="g-3">
        <Row xs={1} md={2} className="g-4">
          <Col>
            <Gergo_Orban_deepgen/>
          </Col>
        </Row>
        
      </Container>
    </section>
  );
}; 
